import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import "react-multi-carousel/lib/styles.css";
import axios from 'axios';

import './Movies.css'

import loadgif from '../../Resources/loading2.gif'
import BASE_URL from '../../constant';


function Movies({release}) {

  const [moviedata, setMovieData] = useState([]);
  const [releasedMovies, setReleasedMovies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(()=>{

    axios.get(`${BASE_URL}/bookmyshow/api/v1/movie`)
    .then(res=>{
      setMovieData(res.data);
      setLoading(false);
    })
    .catch(err => {console.log(err.message);
      setMessage("Some internal error occurred. Try again later :( ");
      setLoading(false);
    });

  },[release]);


  useEffect(() => {
    // Whenever 'movies' state changes, categorize movies
    const moviesArr = [];

    // Checking 'release' prop to check what type of movie should be rendered.
    if(release){
      // if movie status is released then push it to the released array
      moviedata.forEach(movie => {
        if (movie.releaseStatus === 'Released') {
          moviesArr.push(movie);
        }
      })
    }else{

      // if movie status is not released then push it to the released array
      moviedata.forEach(movie => {
        if (movie.releaseStatus !== 'Released') {
          moviesArr.push(movie);
        }
      })

    }

    // now here set state to the released or not released movies
    setReleasedMovies(moviesArr);
  }, [moviedata, release]);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2
    }
  };


  const CustomRight = ({ onClick }) => (
    <button className="arrow right" onClick={onClick} >
        <i  className="fa-solid fa-circle-arrow-right arrowIcon"></i>
    </button>
  );

  const CustomLeft = ({ onClick }) => (
    <button className="arrow left" onClick={onClick} >
        <i  className="fa-solid fa-circle-arrow-left arrowIcon"></i>
    </button>
  );

  return (
    <div>

      <div className="messageContainer">
        {message}
      </div>

      { (loading) ? 
      <div className='gifContainer'>
        <img src={loadgif} alt="Loading..." /><div>Loading Movies...</div>
      </div> : <div className="moviePoster-container">
        <Carousel responsive={responsive} slidesToSlide={3} customLeftArrow={<CustomLeft />} customRightArrow={<CustomRight />}>
        {
          releasedMovies && releasedMovies.map((movie, index)=>{
            return (<div key={index} className='moviePoster'>
            <Link to={"/movie-page/" + movie._id}>
              <img src={movie.posterImage.url} alt="poster1" className='posterimg' />
            </Link>
            <div className="ratings"><i className="fa-solid fa-star icon"></i>&nbsp;  {movie.rating}</div>
            <div className="movie-name">
              {movie.name}
            </div>
            <div className="genre">{movie.genre}</div>
          </div>)
          })
        }
        </Carousel>
      </div>}
    </div>
  )
}

export default Movies
